var applicationLook = {
    bindings : {

    },
    /**
     * @ngInject
     */
    controller : function ApplicationWorkhoursCtrl ($scope, $sce, $location, $timeout, userStore, flux, actions) {
        var ctrl = this;
        var message;
        var formData = {};
        ctrl.messages = [];
        ctrl.looks = [
            {
                title: 'Klassisk',
                value: 'klassisk',
                id: 'klassisk'
            },
            {
                title: 'Stilet',
                value: 'stilet',
                id: 'stilet'
            }
        ];

        function init () {
            ctrl.user = userStore.getUser();
            ctrl.look = ctrl.user.look ? ctrl.user.look : '';
        }

        function link () {
            $timeout(function() {
                ctrl.addMsg({
                    content: $sce.trustAsHtml('Vælg hvordan din ansøgning skal se ud 👀'),
                    type: 'receive'
                });
            }, 500);
        }

        function onUserUpdated(data) {
            if(!_.isEmpty(data)) {
                $timeout(function() {
                    $location.path('/din-ansoegning');
                }, 0);
            }   
        }

        ctrl.addMsg = function addMsg(message) {
            message = {
                content: message.content,
                type: message.type
            };
            ctrl.messages.push(message);
        };

        ctrl.submitLook = function submitLook() {
            if(ctrl.look != "") {
                formData.look = ctrl.look;
                flux.dispatch(actions.UPDATE_USER, formData);
            } else {
                ctrl.addMsg({
                    content: $sce.trustAsHtml('Hov! Du skal vælge et udseende.'),
                    type: 'receive'
                });
            }
            
        };

        ctrl.$onInit = init;
        ctrl.$postLink = link;

        $scope.$listenTo(userStore, ['user'], onUserUpdated);

    },
    templateUrl: './angular/components/application-look.component.html',
};